import { Modal } from '@sgcmpteltd/uikit-next';
import { LoadingSpinner } from '@sgcmpteltd/uikit-react';
import cx from 'clsx';
import { useEffect, useState } from 'react';

import { PiPriceListContent } from '../pi-pricelist-content';
import { MODAL_TRANSITION_DURATION_MS_DEFAULT } from './constants';
import styles from './styles.module.scss';
import type { Component, ModalStep } from './types';

export const PiPriceListModal: Component = ({
  carId,
  slug,
  piPriceListData,
  submodelId,
  isOpen,
  isLoading,
  transitionDurationMs = MODAL_TRANSITION_DURATION_MS_DEFAULT,
  modelIsShortlisted,
  onClose,
  onOpenAlertModal,
}) => {
  const [modalStep, setModalStep] = useState<ModalStep>('default');
  const [modalTitle, setModalTitle] = useState('');

  useEffect(() => {
    if (
      piPriceListData
    ) {
      const { make: piMake, model: piModel } = piPriceListData;

      setModalTitle(`${piMake} ${piModel}`);
    }
  }, [piPriceListData]);

  if (!piPriceListData || !submodelId) {
    return (
      <Modal
        className={cx(
          styles.containerRoot,
          styles.isMediumModal,
        )}
        contentClassName={cx(
          styles.containerModalContent,
          styles.containerPiPricelistModal,
          modalStep === 'errorSubmitResult' && styles.isCenteredContent,
        )}
        isOpen={isOpen}
        title=""
        transitionDurationMs={transitionDurationMs}
        isBackdropStatic
        onClose={onClose}>
        <div className={styles.containerLoadingSpinner}>
          <LoadingSpinner />
        </div>
      </Modal>
    );
  }

  const handleAlertClick = () => {
    onOpenAlertModal();
  };

  const handleSetStep = (step: ModalStep) => {
    setModalStep(step);

    if (step === 'errorSubmitResult') {
      setModalTitle('');
    }
  };

  const handleReportErrorClick = () => {
    setModalTitle('Report Error In New Car Information');
    setModalStep('reportError');
  };

  const handleCloseModal = () => {
    setModalStep('default');
    onClose?.();
  };

  return (
    <Modal
      className={cx(
        styles.containerRoot,
        styles.isMediumModal,
        modalStep === 'errorSubmitResult' && styles.isSummitted,
      )}
      contentClassName={cx(
        styles.containerModalContent,
        styles.containerPiPricelistModal,
        modalStep === 'errorSubmitResult' && styles.isCenteredContent,
      )}
      headerClassName={cx(
        styles.containerHeader,
        modalStep !== 'default' && styles.isHeaderCentered,
      )}
      isOpen={isOpen}
      title={modalTitle}
      transitionDurationMs={transitionDurationMs}
      onClose={handleCloseModal}>
      {isLoading
        ? (
          <div className={styles.containerLoadingSpinner}>
            <LoadingSpinner />
          </div>
        )
        : (
          <PiPriceListContent
            carId={carId}
            modalStep={modalStep}
            modelIsShortlisted={modelIsShortlisted}
            piPriceListData={piPriceListData}
            slug={slug}
            submodelId={submodelId}
            onHandleSetStep={handleSetStep}
            onOpenAlertModal={handleAlertClick}
            onOpenReportErrorModal={handleReportErrorClick} />
        )}
    </Modal>
  );
};
